const TOOLTIPS = {
    INSURANCE_SUM: 'Общая стоимость груза (руб.)',
    CARGO_TYPE: 'Тип груза',
    CARGO_PACKAGING: 'Вид упаковки груза',
    CARGO_LOADING_TYPE: 'Габаритность груза',
    DISTANCE_AREA: 'Регион',
    DISTANCE_COUNT: 'Длина маршрута',
    TRANSPORT_GUARD: 'Сопровождение груза',
    TRANSPORT_SHIPPING: 'Способ перевозки',
    TRANSPORT_TYPE: 'Используемые виды транспорта',
    TRANSPORT_STORAGE: 'Временное хранение груза',
    TRANSPORT_LOADING_COUNT: 'Погрузо-разгрузочные работы',
    TRANSPORT_LONG_DELIVERY:
        'Расстояние перевозки с помощью автомобильного транспорта, в том числе дистанция довоза/подвоза от/до аэропорта, ж/д станции и т.п.',
    CONTACT_PHONE: 'Телефон',
    CONTACT_NАМЕ: 'Ваше Имя',
    CONTACT_COMPANY: 'Название Вашей Организации',
    CALCULATION_ID: 'Идентификатор текущего расчёта',
}

export default TOOLTIPS
